import { matchLocalePrefix, routing, type AppLocale } from '@/i18n/routing';

/**
 * Copy for `global-error.tsx`. That boundary replaces the root layout, so it renders outside the
 * next-intl provider and cannot use `useTranslations`; loading a whole message file there would
 * bloat the fallback bundle. These three strings mirror `Common.errorStateTitle`,
 * `Common.errorStateDescription` and `Common.buttons.retry`; `globalErrorCopy.test.ts` fails if
 * they drift from the message files.
 */
const COPY: Record<AppLocale, { title: string; description: string; retry: string }> = {
  'en-AU': {
    title: 'Something went wrong',
    description: 'Please try again. If it keeps happening, refresh the page.',
    retry: 'Retry',
  },
  'zh-TW': {
    title: '發生錯誤',
    description: '請再試一次。若問題持續，請重新整理頁面。',
    retry: '重試',
  },
  'ja-JP': {
    title: '問題が発生しました',
    description: 'もう一度お試しください。解決しない場合はページを再読み込みしてください。',
    retry: '再試行',
  },
  'fr-FR': {
    title: 'Une erreur s’est produite',
    description: 'Veuillez réessayer. Si le problème persiste, actualisez la page.',
    retry: 'Réessayer',
  },
};

/** Copy for the locale a pathname is prefixed with; the default locale when it has none. */
export function globalErrorCopy(pathname: string) {
  const locale = matchLocalePrefix(pathname) ?? routing.defaultLocale;
  return { locale, ...COPY[locale] };
}
